import React, { useEffect, useState } from "react";
// ANT DESIGN COMPONENTS
import { Form, Spin, Divider, Drawer, Input, Button } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserShield, faUserLock } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateOpenModalCreateNewRole } from "../../../redux/roles/roleSlice";
import { usePostRoleMutation } from "../../../redux/roles/roleAPI";
import { updateOrganizationAndChilds } from "../../../redux/organizations/organizationSlice";
// COMPONENTS
import RolesDinamicRolesTree from "./RolesDinamicRolesTree";
import GlobalAlert2 from "../../home/GlobalAlert2";
// AUTHORIZATION
import GETJwtToken from "../../../redux/authentication/authentication";
// COMPONENTS
import OrganizationSelectOrganizationSubOrganization from "../organizations/OrganizationSelectOrganizationSubOrganization";
// INTERFACES
import { RootState } from "../../../app/store";

function RolesCreateRoleForm() {
	// ************************************************ */
	// LOCAL STORAGE AND VARIABLES ******************** */
	const dispatch = useDispatch();
	const { openModalCreateNewRole } = useSelector((state: any) => state.role);
	const { organizationAndChilds } = useSelector((state: any) => state.organization);
	const { userLogged } = useSelector((state: any) => state.home);
	const [form] = Form.useForm();
	const [organizationsAndChildsIsLoading, setOrganizationsAndChildsIsLoading] = useState(false);
	const [menu, setMenu] = useState<any>({});
	const [t] = useTranslation("global");
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const [
		postRole,
		{
			isSuccess: isSuccessPostRole,
			isLoading: isLoadingPostRole,
			isError: isErrorPostRole,
			error: errorPostRole,
			reset: resetPostRole,
		},
	] = usePostRoleMutation();

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const cleanOrganizationsList = () => {
		dispatch(
			updateOrganizationAndChilds({
				childs: [],
			})
		);
	};

	const onClose = () => {
		cleanOrganizationsList();
		dispatch(updateOpenModalCreateNewRole(false));
	};

	const onFinish = async (values: any) => {
		const token = await GETJwtToken();
		let roleMenu: any = {
			active: true,
			offline: true,
			name: values.name,
			pages: [],
			actions: [],
		};
		if (menu && menu.active) {
			roleMenu = menu;
			if (roleMenu.name === "") {
				roleMenu.name = values.name;
			}
		}
		//
		const BODY = {
			token,
			body: {
				active: true,
				offline: true,
				menu: JSON.stringify(roleMenu),
				name: values.name,
				org_id: organizationAndChilds.data.idOrganizationSelected
					? organizationAndChilds.data.idOrganizationSelected
					: "",
			},
		};
		postRole(BODY);
	};

	const handleCloseModal = () => {
		cleanOrganizationsList();
		dispatch(updateOpenModalCreateNewRole(false));
	};

	// ************************************************* */
	// USE EFFECT ************************************** */
	useEffect(() => {
		if (openModalCreateNewRole) {
			resetPostRole();
			form.resetFields();
			cleanOrganizationsList();
		}
	}, [openModalCreateNewRole]);

	useEffect(() => {
		dispatch(updateOpenModalCreateNewRole(false));
	}, [isSuccessPostRole, isErrorPostRole]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Drawer width='550' placement='right' onClose={onClose} closable={false} open={openModalCreateNewRole}>
			<Spin spinning={isLoadingPostRole || organizationsAndChildsIsLoading} tip={t("general.loading")}>
				<div>
					<Divider orientation='left' className='generalStyles__drawerDivider'>
						<h5>
							<FontAwesomeIcon icon={faUserShield} className='generalStyles__info generalStyles__mrFix' />
							{t("organizationManagement.createNewRole")}
						</h5>
					</Divider>
				</div>
				<Form form={form} layout='vertical' onFinish={onFinish}>
					<div className='container'>
						<div className={`drawer__box__${theme} row`}>
							<div className='col-12'>
								{/** ---------------------------------------------------- */}
								{/** NAME */}
								<div className='col-md-12 mt-3'>
									<div className='generalStyles__flex'>
										<div className='generalStyles__inputFlexName'>
											<span className='generalStyles__inputFlexRequired'>*</span>
											<span> {t("organizationManagement.roleName")}</span>
										</div>
										<div className='generalStyles__width100'>
											<Form.Item
												name='name'
												rules={[
													{
														required: true,
														message: t("organizationManagement.formRequiredMessage.roleName"),
													},
													{
														max: 50,
														message: t("organizationManagement.formRequiredMessage.roleNameMax"),
													},
												]}
											>
												<Input className='generalStyles__input' size='small' />
											</Form.Item>
										</div>
										<div>
											<div className='generalStyles__infoTooltipIconBlank' />
										</div>
									</div>
								</div>
							</div>
						</div>
						{/** ---------------------------------------------------- */}
						{/** GET ORGANIZATION AND CHILDS ----------- */}
						<OrganizationSelectOrganizationSubOrganization
							setOrganizationsAndChildsIsLoading={setOrganizationsAndChildsIsLoading}
						/>
						<br />
						<Divider orientation='left' className='generalStyles__drawerDivider'>
							<h5>
								<FontAwesomeIcon icon={faUserLock} className='generalStyles__info generalStyles__mrFix' />
								{t("organizationManagement.permissions")}
							</h5>
						</Divider>
						<div className={`drawer__box__${theme} row`}>
							<RolesDinamicRolesTree setMenu={setMenu} roleData={userLogged.role} connectionType='active' />
						</div>
					</div>
					{/** ---------------------------------------------------- */}
					<div className='mt-4'>
						<div>
							<Button type='default' onClick={handleCloseModal} className='buttonStyle__3'>
								{t("general.close")}
							</Button>
							<Button htmlType='submit' disabled={isLoadingPostRole} className='buttonStyle__3' type='primary'>
								{t("general.save")}
							</Button>
						</div>
					</div>
				</Form>
			</Spin>
			{/** ---------------------------------------------------- */}
			{/** GLOBAL ALERT */}
			<GlobalAlert2
				isError={isErrorPostRole}
				isSuccess={isSuccessPostRole}
				requestType='POST'
				error={errorPostRole}
				name='Role'
			/>
		</Drawer>
	);
}

export default RolesCreateRoleForm;
